// Download Icon:

// Core
import React from 'react'

const Download = () => (
  <svg width="100%" viewBox="0 0 32 32">
    <path d="M7 0v17h-4l7 9 7-9h-4v-17h-6zm-7 29v3h20v-3h-20z" transform="translate(6)" />
  </svg>
)

export default Download
